import React from 'react';
import CircularProgressbar from 'react-circular-progressbar';
// styles
import './CircleProgress.css';
import 'react-circular-progressbar/dist/styles.css';

const CircleProgress = ({ progress, ...restProps }) => (
  <CircularProgressbar percentage={progress} {...restProps} />
);

export default CircleProgress;



// WEBPACK FOOTER //
// ./src/components/CircleProgress/CircleProgress.jsx